import { memo } from 'react';

import RideCompleted from './RideCompleted';

const ListRidesCompleted = memo(function ListRidesCompleted({ rides }) {
    if (!rides.length) {
        return null;
    }

    return (
        <div>
            <p className='text-bold text-uppercase'>Courses terminées</p>
            {rides.map((ride) => (
                <RideCompleted key={ride.id} ride={ride} />
            ))}
        </div>
    );
});

export default ListRidesCompleted;
